/* sidemenu */
$(function() {
    const toggle = $('.sidemenuToggle');
    toggle.click(function(event) {
        event.preventDefault();
        $(this)
            .parent()
            .toggleClass('__active');
        $(this)
            .siblings()
            .slideToggle();
    });
});
